import pako from "pako";

/* ---------------------------
   Helpers: binary <-> base64
---------------------------- */

// Uint8Array → binary string
function uint8ToBinary(uint8) {
  let binary = "";
  for (let i = 0; i < uint8.length; i++) {
	binary += String.fromCharCode(uint8[i]);
  }
  return binary;
}

// binary string → Uint8Array
function binaryToUint8(binary) {
  const len = binary.length;
  const uint8 = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
	uint8[i] = binary.charCodeAt(i);
  }
  return uint8;
}

/* ---------------------------
   URL-safe base64 helpers
---------------------------- */

function toBase64Url(str) {
  return str.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function fromBase64Url(str) {
  str = str.replace(/-/g, "+").replace(/_/g, "/");
  while (str.length % 4 !== 0) str += "=";
  return str;
}

/* ---------------------------
   Public API
---------------------------- */

export function encodeState(state) {
  const json = JSON.stringify(state);

  // pako returns Uint8Array
  const deflated = pako.deflate(json);

  // convert to binary
  const binary = uint8ToBinary(deflated);

  // base64 encode
  const b64 = btoa(binary);

  return toBase64Url(b64);
}

export function decodeState(encoded) {
  try {
	const b64 = fromBase64Url(encoded);

	const binary = atob(b64);
	const uint8 = binaryToUint8(binary);

	const inflated = pako.inflate(uint8, { to: "string" });
	return JSON.parse(inflated);
  } catch (error) {
	console.warn("Failed to decode state:", error);
	return null;
  }
}
